module.exports = __webpack_public_path__ + "img/recipes.ac88359d.png";